<script setup>
const props = defineProps({
    progress: {
        type: Number,
        default: 0,
    },
});
const progressPercent = props.progress;
</script>
<template>
    <div
        class="progress-bar progress-bar-custom"
        role="progressbar"
        :style="{ width: progressPercent + '%' }"
        aria-valuenow="50"
        aria-valuemin="0"
        aria-valuemax="100"
    >
        {{ progressPercent }}%
    </div>
</template>
<style>
.progress-bar-custom {
    background-color: var(--bs-primary-bg-subtle);    
}
.progress, .progress-stacked {
    height: 1.5rem !important;
}
</style>